var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task",class:_vm.stateClass,on:{"click":function($event){return _vm.$emit('taskStateChanged', _vm.task)}}},[_c('span',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('taskDeleted', _vm.task)}}},[_vm._v("x")]),_c('p',[_vm._v(_vm._s(_vm.task.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }